/* Optimistic client-side price updates on the cart page.
   Dawn's cart.js debounces the AJAX update and then re-renders on the
   server response, which takes 300–700ms — long enough to feel sluggish.
   This script snapshots each line's unit price on load, then updates the
   line-total and subtotal DOM immediately on quantity input, before the
   server call. When the server response arrives, Dawn re-renders those
   same fields with the authoritative value — usually identical, so no
   flicker; if different (e.g. discount tier changed), Dawn's value wins. */
(function () {
  var isCartPage = document.querySelector('main[data-template="cart"]');
  if (!isCartPage) return;

  var CURRENCY_FORMAT = null;  // built from a rendered price on init
  var SUBTOTAL_SELECTORS = [
    '.totals__total-value',
    '.totals__subtotal-value',
    '[data-cart-total]',
    'cart-items .totals__total-value'
  ].join(',');

  function parseMoney(text) {
    if (!text) return NaN;
    // Strip everything except digits, dot, comma. Handles "$1,234.56", "€1.234,56", "1234".
    var cleaned = text.replace(/[^\d.,-]/g, '');
    // If the last separator is a comma with 2 digits after → decimal comma format.
    var m = cleaned.match(/[.,](\d{2})$/);
    var decimalSep = m && cleaned.indexOf(',') > cleaned.lastIndexOf('.') ? ',' : '.';
    if (decimalSep === ',') {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      cleaned = cleaned.replace(/,/g, '');
    }
    return parseFloat(cleaned);
  }

  function detectFormat(sampleText) {
    if (!sampleText) return null;
    var match = sampleText.match(/^([^\d-]*)([\d.,\s-]+)([^\d.,-]*)$/);
    if (!match) return null;
    return { prefix: match[1] || '', suffix: match[3] || '' };
  }

  function formatMoney(amount) {
    var fmt = CURRENCY_FORMAT || { prefix: '$', suffix: '' };
    var str = amount.toFixed(2);
    // Add thousands separators.
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.prefix + parts.join('.') + fmt.suffix;
  }

  // Dawn's cart-item line total lives inside a plain <span class="price price--end">
  // (or <dd class="price price--end"> for discounted lines).
  var LINE_TOTAL_SELECTOR = '.cart-item__totals .cart-item__price-wrapper .price';

  function collectLineData() {
    var lines = [];
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var qtyInput = row.querySelector('input[type="number"]');
      var totalEl  = row.querySelector(LINE_TOTAL_SELECTOR);
      if (!qtyInput || !totalEl) return;

      // Sample the displayed price format if we haven't yet.
      if (!CURRENCY_FORMAT) CURRENCY_FORMAT = detectFormat(totalEl.textContent.trim());

      var qty = parseInt(qtyInput.value, 10) || 1;
      var lineTotal = parseMoney(totalEl.textContent);
      if (isNaN(lineTotal) || qty <= 0) return;

      lines.push({
        row: row,
        qtyInput: qtyInput,
        totalEls: row.querySelectorAll(LINE_TOTAL_SELECTOR),
        unitPrice: lineTotal / qty
      });
    });
    return lines;
  }

  function updateOptimistic(lines) {
    var subtotal = 0;
    lines.forEach(function (line) {
      var qty = parseInt(line.qtyInput.value, 10) || 0;
      if (qty < 0) qty = 0;
      var lineTotal = line.unitPrice * qty;
      subtotal += lineTotal;
      line.totalEls.forEach(function (el) {
        el.textContent = formatMoney(lineTotal);
      });
    });
    document.querySelectorAll(SUBTOTAL_SELECTORS).forEach(function (el) {
      // Preserve any surrounding text like "USD" — replace only the money-looking portion.
      var current = el.textContent;
      var replaced = current.replace(/[^\s\w]*\d[\d.,]*[^\s\w]*/, formatMoney(subtotal));
      el.textContent = replaced === current ? formatMoney(subtotal) : replaced;
    });
  }

  var lines = collectLineData();
  if (!lines.length) return;

  // React to both the +/- stepper clicks and direct input typing.
  document.addEventListener('input', function (e) {
    if (e.target.matches('input[type="number"]')) {
      updateOptimistic(lines);
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.quantity__button')) {
      // Buttons dispatch input asynchronously — nudge to next tick.
      setTimeout(function () { updateOptimistic(lines); }, 0);
    }
  });

  // Re-snapshot after Dawn re-renders (server response), so unit prices
  // reflect any discount changes the server applied.
  document.addEventListener('cart-update', function () {
    setTimeout(function () { lines = collectLineData(); }, 100);
  });
})();
